import { useState } from 'react';
import { useNegativeMarks } from 'hook/negativeMarks.hook';
import { potentialPaymentHistoryByGrade } from 'types/creditReport.constants';

export const useGoalNegativeMarks = props => {
  const [showHowItIsCalculated, setShowHowItIsCalculated] = useState(false);
  const showHideModal = () => {
    setShowHowItIsCalculated(!showHowItIsCalculated);
  };

  const paymentHistoryAnalysis =
    props?.creditInfo?.creditScoreAnalysis?.paymentHistory;
  const paymentHistoryGrade = paymentHistoryAnalysis?.grade;
  const { actionPlanSteps, delinquentAccounts, derogatoryAccounts } =
    useNegativeMarks(props?.creditInfo, props?.eventHandler, props?.module);

  return {
    showHideModal,
    showHowItIsCalculated,
    actionPlanSteps,
    delinquentAccounts,
    derogatoryAccounts,
    totalNegativeMarks: delinquentAccounts.length + derogatoryAccounts.length,
    paymentHistoryGrade,
    potentialPaymentHistoryGrade:
      potentialPaymentHistoryByGrade[paymentHistoryGrade],
  };
};
